import * as React from "react";

import { Confirm, Document } from "./Chapters";

export default (key, method) => {
  switch (key) {
    case "DOCUMENT":
      return <Document method={method} />;
    default:
      return <Confirm />;
  }
};
